import React, { useEffect, useRef, useState } from "react";
import "../../styles/Dashboard.css";
import Footer from "../../layouts/Footer";
import mainImg from "../../assets/mainImg.png";
import mobile from "../../assets/mobile.png";
import icon1 from "../../assets/Complaint.png";
import Navbar from "../../layouts/Navbar";
import api from "../../api/config";
import NoDataFound from "../../components/common/NoDataFound";
import UserSpaceFeedList from "../../components/user/UserSpaceFeedList";
import SpaceFeedSearch from "../../components/user/SpaceFeedSearch";
import { ToastContainer, toast } from "react-toastify";
import SkeletonLoader from "../../components/common/SkeletonLoader";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { useNavigate } from "react-router-dom";
const Dashboard = () => {
  const settings = {
    dots: true,
    infinite: true,
    speed: 1500,
    arrows: false,
    autoplay: true,
    autoplaySpeed: 1500,
    slidesToShow: 7,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  };
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const [spaceFeedList, setSpaceFeedList] = useState([]);
  const [hasMore, setHasMore] = useState(true);
  const [page, setPage] = useState(0);
  const [categoryList, setCategoryList] = useState([]);
  const [subCategoryList, setSubCategoryList] = useState([]);
  const [searchPayload, setSearchPayload] = useState({
    category: [],
    subCategory: [],
    location: "",
  });
  const [searchLoading, setSearchLoading] = useState(false);
  const fetchData = async (page) => {
    //console.logpage, "page");
    const response = await api.get(`/space-feeds?page=${page}&size=4`);
    //console.logresponse, "response");
    return response?.data?.response?.spaceFeeds;
  };

  const loadMore = async () => {
    setLoading(true);
    try {
      const newProducts = await fetchData(page);
      if (newProducts.length === 0) {
        setHasMore(false);
      }
      setSpaceFeedList([...spaceFeedList, ...newProducts]);
      setPage(page + 1);
    } catch (error) {
      toast.error("Something went wrong");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    loadMore();
  }, []);
  const truncateText = (text, maxLength) => {
    if (text.length > maxLength) {
      return text.substring(0, maxLength) + "...";
    }
    return text;
  };

  const handleSubmit = async (categoryId) => {
    setSearchLoading(true);
    try {
      const response = await api.post("/search-space-feed", {
        category: [categoryId],
      });
      if (response?.data?.status === 200) {
        navigate("/property-search", {
          state: { searchData: response.data },
        });
      }
      //console.logresponse, "response");
      // setSpaceFeedList() Will  be used to update the state of space feed list in parent component
    } catch (error) {
      toast.error("Something went wrong");
      //console.logerror, "error");
    } finally {
      setSearchLoading(false);
    }
  };

  const handleTagClick = async (action, id) => {
    setSearchLoading(true);
    try {
      let response = null;
      if (action === "category") {
        response = await api.post("/search-space-feed", {
          category: [id]
        });
      } else if (action === "location"){
        response = await api.post("/search-space-feed", {
          location: id
        })
      }
      
      else {
        response = await api.post("/search-space-feed", {
          subCategory: [id],
        });
      }
      if (response?.data?.status === 200) {
        navigate("/property-search", {
          state: { searchData: response.data },
        });
      }
      //console.logresponse, "response");
      // setSpaceFeedList() Will  be used to update the state of space feed list in parent component
    } catch (error) {
      toast.error("Something went wrong");
      //console.logerror, "error");
    } finally {
      setSearchLoading(false);
    }
  };
  return (
    <>
      <Navbar />
      <ToastContainer />
      <div className="">
        <div className="main-img">
        <picture>
        <source media="(max-width: 768px)" srcSet={mobile} />
        <img
          className="img-fluid responsive"
          style={{ width: "100%" }}
          src={mainImg}
          alt="Business Meeting"
        />
      </picture>
          <SpaceFeedSearch
            setSpaceFeedList={setSpaceFeedList}
            searchLoading={searchLoading}
            setSearchLoading={setSearchLoading}
            categoryList={categoryList}
            subCategoryList={subCategoryList}
            setCategoryList={setCategoryList}
            setSubCategoryList={setSubCategoryList}
            setSearchPayload={setSearchPayload}
            searchPayload={searchPayload}
            handleTagClick={handleTagClick}
          />
        </div>
        <div className="container-fluid">
          <div className="mx-3 mt-3">
            <h3>Our Business</h3>
            {!loading && spaceFeedList?.length === 0 && <NoDataFound />}
            {loading && page === 0 ? (
              <>
                <SkeletonLoader count={4} />
              </>
            ) : (
              spaceFeedList?.length > 0 && (
                <>
                  <UserSpaceFeedList
                    spaceFeedList={spaceFeedList}
                    loadMore={loadMore}
                    hasMore={hasMore}
                  />
                </>
              )
            )}
          </div>
        </div>

        {/* <div className="slider-container container-fluid dashboardSlider">
          {categoryList.length > 0 && (
            <Slider {...settings} className="slider-menu">
              {categoryList.map((item, index) => (
                <div
                  key={index}
                  className="d-flex row justify-content-center align-items-center icon-cards iconCardSlider "
                  style={{ width: "100% !important" }}
                  onClick={(e) => {
                    handleSubmit(item?.categoryId);
                  }}
                >
                  {item?.image ? (
                    <img
                      src={item?.image}
                      alt="Business Meeting"
                      className="slider-image"
                      height={75}
                      width={50}
                    />
                  ) : (
                    <img
                      src={icon1}
                      alt="Business Meeting"
                      className="slider-image"
                      height={50}
                      width={50}
                    />
                  )}
                  <strong>{truncateText(item?.category, 10)}</strong>
                </div>
              ))}
            </Slider>
          )}
        </div> */}
      </div>
      <Footer />
    </>
  );
};

export default Dashboard;
